import { bindActionCreators } from 'redux'

export function mapDispatchToProps(dispatch, ownProps) {
  return {
    globalActions: bindActionCreators(require('../actions/global'), dispatch),
    sessionActions: bindActionCreators(require('../actions/session'), dispatch),
    screenActions: bindActionCreators(require('../actions/screen'), dispatch),
    userActions: bindActionCreators(require('../actions/user'), dispatch),
    serviceActions: bindActionCreators(require('../actions/service'), dispatch),
    accountActions: bindActionCreators(require('../actions/account'), dispatch),
    messageActions: bindActionCreators(require('../actions/message'), dispatch),
    reportActions: bindActionCreators(require('../actions/report'), dispatch)
  }
}
